// @ts-nocheck
import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import SinapTheme from '../../styles/SinapTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FormularioAlta } from "../FormularioAlta";
import { Solicitudes } from "./Solicitudes";
import { useHistory } from "react-router-dom";
import { AltaDeUsuario } from "./AltaDeUsuario";
import { useAuth } from "../../Auth/State/AuthContext";

const Root = styled('div')(({ theme }) => ({
    background: "#ffffff",
    width: '200%',
    marginTop: '-1.5%',
    [theme.breakpoints.down('lg')]: {
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.up('md')]: {
        width: '100%',
        height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
        width: '100%',
        height: '100%',
    },
}));

const DrawerDiv = styled('div')(({ theme }) => ({
    background: "#ffffff",
}));


const useStyles = makeStyles(() => ({
    margineDense: {
        marginTop: "8px",
        marginBottom: "4px",
    },
    root: {
        background: "#ffffff",
        width: '100%',
        marginLeft: '-1.5%',
        marginTop: '-1.5%'
    }
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    const searchParams = new URLSearchParams(document.location.search)


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {

    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

export const TabsUsuarios = () => {
    const { hasRole } = useAuth();
    const classes = useStyles();
    const searchParams = new URLSearchParams(document.location.search)
    const theme = useTheme();
    const matches = useMediaQuery('(min-width:1000px)');

    const getInitialTab = () => {
        if (searchParams.get('tab')) {
            return parseInt(searchParams.get('tab'));
        }

        if (hasRole(["ROLE_CREAR_USUARIO"])) return 0;
        if (hasRole(["ROLE_OBTENER_SOLICITUDES_DE_ALTAS"])) return 1;
        if (hasRole(["ROLE_OBTENER_USUARIOS"])) return 2;

        return 0;
    };

    const [value, setValue] = React.useState(getInitialTab());

    const handleChange = (event, newValue) => {
        const isDisabled =
            (newValue === 0 && !hasRole(["ROLE_CREAR_USUARIO"])) ||
            (newValue === 1 && !hasRole(["ROLE_OBTENER_SOLICITUDES_DE_ALTAS"])) ||
            (newValue === 2 && !hasRole(["ROLE_OBTENER_USUARIOS"]));

        if (!isDisabled) {
            setValue(newValue);
        }
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const hasAnyAccess = hasRole(["ROLE_CREAR_USUARIO"]) || hasRole(["ROLE_OBTENER_SOLICITUDES_DE_ALTAS"]) || hasRole(["ROLE_OBTENER_USUARIOS"]);

    if (!hasAnyAccess) {
        return (
            <Box p={2} textAlign="center">
                <h3>No tienes acceso a ningún sector de este módulo.</h3>
            </Box>
        );
    }

    return <>
        <>
            <Box>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={SinapTheme}>
                        <DrawerDiv>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="fullWidth"
                                color="primary"
                                aria-label="full width tabs example"
                            >
                                <Tab
                                    label="Llenar formulario"
                                    disabled={!hasRole(["ROLE_CREAR_USUARIO"])}
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label="Solicitudes"
                                    disabled={!hasRole(["ROLE_OBTENER_SOLICITUDES_DE_ALTAS"])}
                                    {...a11yProps(1)}
                                />
                                <Tab
                                    label="Alta de usuario"
                                    disabled={!hasRole(["ROLE_OBTENER_USUARIOS"])}
                                    {...a11yProps(2)}
                                />
                            </Tabs>
                        </DrawerDiv>
                    </ThemeProvider>
                </StyledEngineProvider>
            </Box>
            <Box>

                <TabPanel value={value} index={0} dir={theme.direction}>
                    {hasRole(["ROLE_CREAR_USUARIO"]) && <FormularioAlta tab={0} mostrarLegajoAlumno={true} mostrarContrasena={true} />}
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    {hasRole(["ROLE_OBTENER_SOLICITUDES_DE_ALTAS"]) && <Solicitudes />}
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    {hasRole(["ROLE_OBTENER_USUARIOS"]) && <AltaDeUsuario />}
                </TabPanel>
            </Box>
        </>

    </>;
}